export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="mt-8 pt-6 pb-10 text-center text-[0.7rem] text-muted">
      &copy; {year} Kha Do
    </footer>
  );
}
